/*
 * @Author: hfxie
 * @Date: 2022-08-17 14:37:30
 * @LastEditors: hfxie
 * @LastEditTime: 2022-08-17 17:38:43
 * @Description: 常量名
 */

const DEMO = "示例常量";


const CONSTNAME = {
  DEMO,
};

export default CONSTNAME;
